import type { FC } from "react";

type VideoViewerProps = {
  fileId: string;
};

export const VideoViewer: FC<VideoViewerProps> = ({ fileId }) => {
  return (
    <div className="flex items-center justify-center h-full w-full p-2 bg-zinc-100 dark:bg-zinc-900">
      <video
        src={`/api/file/${fileId}`}
        controls
        className="max-h-full max-w-full rounded-lg"
      >
        Your browser does not support video playback.
      </video>
    </div>
  );
};
